var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-relative gl-block gl-h-2 gl-w-11 gl-rounded-sm gl-bg-status-neutral",attrs:{"role":"status","aria-label":_vm.ariaLabel}},[_c('span',{staticClass:"gl-absolute gl-block gl-h-2 gl-rounded-sm",style:(_vm.pillStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }